import { useState, useRef, memo } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";

function UploadVideoFile({
    changerEtapeCollecteParticipation,
    participation,
}) {
    let [file, setFile] = useState();
    const fileRef = useRef();
    const [recordingState, setRecordingState] = useState('not-started');
    const readerRef = useRef({});
    const [recommencer, setRecommencer] = useState(false);

    const recommencerEnregistrement = async () => {
        setRecommencer(false);
        setRecordingState('not-started');
    }

    const readFile = async (e) => {
    }
    const endReadFile = async (e) => {
        setRecordingState('finished');
        participation.video = {}
        participation.video.url = URL.createObjectURL(file);
        participation.video.blob = e.target.result;
    }
    const uploadFromFile = async (e) => {
        setRecordingState('waiting');
        console.log('uploadFromFile');
        file = e.target.files[0];
        fileRef.current = file;
        readerRef.current = new FileReader();
        readerRef.current.onload = readFile;
        readerRef.current.onloadend = endReadFile;
        if (!file) {
            return;
        }
        if (file.type.includes('image')) {
            return { src: URL.createObjectURL(file), file: file };
        }
        setFile(file);
        readerRef.current.readAsArrayBuffer(file);
        setRecommencer(true);
    };
    return (
        <>
            <div className={recordingState === 'not-started' ? 'custom-upload-video' : 'custom-upload-video fond-gris-widget'}>
                <Row className="custom-top-video">
                    <Col>
                        {!recommencer &&
                            <Form.Group controlId="uploadVideoFile">
                                <Form.Control type="file" accept={'video/*'} size="sm" onChange={uploadFromFile} ref={fileRef} id="selecteur" />
                            </Form.Group>
                        }
                    </Col>
                </Row>
                {
                    // Permet de forcer la mise à jour de l'aperçu
                }
                <p style={{ display: "none" }}>{recordingState}</p>
                {recordingState === 'finished' &&
                    <>
                        <Row className="text-center text-16 titre-player">
                            <Col>
                                Aperçu de votre vidéo
                            </Col>
                        </Row>
                        <Row className="text-center video-preview">
                            <Col>
                                <video width="300" muted autoplay="true" controls>
                                    <source src={URL.createObjectURL(file)} />
                                </video>
                            </Col>
                        </Row>
                    </>
                }
                {recommencer &&
                    <Row className="text-center">
                        <Col>
                            <Button onClick={recommencerEnregistrement} className="btn-refaire-enregistrement-vocale">Recommencer l'enregistrement</Button>
                        </Col>
                    </Row>
                }
                {recordingState === 'finished' &&
                    <Row className="custom-commandes">
                        <Col>
                            <Button onClick={changerEtapeCollecteParticipation} disabled={recordingState !== 'finished'}>Continuer</Button>
                        </Col>
                    </Row>
                }

            </div>
        </>
    )
};
export default memo(UploadVideoFile);